function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "392.76 3.999 112.158 106.45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque 1",
    transform: "matrix(4.16667, 0, 0, 4.16667, -198.748993, -374.542999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.305,116.398L163.829,116.398C163.829,104.509 154.019,94.837 141.962,94.837L141.962,93.361C154.834,93.361 165.305,103.693 165.305,116.398",
    style: {
      fill: "rgb(73,156,210)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.325,108.468C164.554,101.01 158.51,94.785 150.932,92.609L151.272,91.426C159.27,93.723 165.649,100.299 167.521,108.183L166.325,108.468Z",
    style: {
      fill: "rgb(72,156,210)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.987,101.469C166.161,97.487 163.047,94.014 159.226,91.691L159.737,90.85C163.727,93.276 166.972,96.899 168.88,101.058L167.987,101.469Z",
    style: {
      fill: "rgb(72,156,210)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonar);
export default __webpack_public_path__ + "static/media/sonar.216b9a4ea90e57a931636123ad50b6bf.svg";
export { ForwardRef as ReactComponent };